import React from "react";
import ReactDOM from "react-dom/client";
import { StartPage } from "./features/start/StartPage";
import { shouldShowStartPage } from "./features/start/startRoute";
import {
  isTauriRuntime,
  resolveAppBootstrap,
} from "./platform/appSurface";
import { createRuntimeMarketQuoteGateway } from "./platform/marketQuoteGateway";
import { createTauriPortfolioRepository } from "./platform/tauriPortfolioRepository";
import {
  applyDocumentUiLocale,
  browserLanguageTags,
  I18nProvider,
  readUiLocale,
} from "./i18n";
import "./styles/global.css";

const bootstrap = resolveAppBootstrap(window.location.href);
if (window.location.pathname !== bootstrap.pathname) {
  window.history.replaceState({}, "", bootstrap.pathname);
}
document.documentElement.dataset.appSurface = bootstrap.surface;
applyDocumentUiLocale(
  readUiLocale(window, browserLanguageTags(window.navigator)),
);

async function render() {
  const root = ReactDOM.createRoot(document.getElementById("root")!);

  if (
    bootstrap.surface === "web" &&
    (bootstrap.pathname === "/admin" || bootstrap.pathname === "/admin/")
  ) {
    const { AdminPage } = await import(
      "./features/operations/AdminPage"
    );
    root.render(
      <React.StrictMode>
        <AdminPage />
      </React.StrictMode>,
    );
    return;
  }

  if (shouldShowStartPage(bootstrap)) {
    root.render(
      <React.StrictMode>
        <I18nProvider>
          <StartPage />
        </I18nProvider>
      </React.StrictMode>,
    );
    return;
  }

  await import("pixi.js/unsafe-eval");
  const [{ Assets }, { App }] = await Promise.all([
    import("pixi.js"),
    import("./App"),
  ]);

  if (isTauriRuntime()) {
    Assets.setPreferences({
      preferWorkers: false,
      preferCreateImageBitmap: false,
      crossOrigin: null,
    });
  }

  const marketQuoteGateway = createRuntimeMarketQuoteGateway();
  const portfolioRepository = isTauriRuntime()
    ? createTauriPortfolioRepository()
    : undefined;

  const showWebFarmTelemetry =
    bootstrap.surface === "web" && bootstrap.pathname === "/farm";
  const WebFarmTelemetry = showWebFarmTelemetry
    ? (await import("./features/operations/WebFarmTelemetry")).WebFarmTelemetry
    : null;

  root.render(
    <React.StrictMode>
      <I18nProvider>
        {WebFarmTelemetry && <WebFarmTelemetry />}
        <App
          surface={bootstrap.surface}
          {...(bootstrap.initialAction
            ? { initialAction: bootstrap.initialAction }
            : {})}
          {...(portfolioRepository ? { portfolioRepository } : {})}
          {...(marketQuoteGateway ? { marketQuoteGateway } : {})}
        />
      </I18nProvider>
    </React.StrictMode>,
  );
}

void render();
